export default function LongArrow({ ...props }) {
  return (
    <svg viewBox="0 0 17.414 49.889" {...props}>
      <g fill="none" stroke="#001848">
        <path d="M8.707.5v48.889" />
        <path d="m.707 41.389 8 8 8-8" />
      </g>
    </svg>
  );
}
